import type { OutgoingAction } from '../../../services/workQueue';

// The backend picks the refinement lane (V2 ODO-managed or not), so match the edge by where it landed.
export function triggerCompletion(
    actions: readonly OutgoingAction[],
    landedOn: string
): OutgoingAction | undefined {
    return actions.find((a) => a.to === landedOn);
}
